<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    content
  </div>
</template>

<script setup>
import {useOpacity} from '@/hooks';
const opacity = useOpacity();
</script>
